import React from 'react';
import { useSnackbar } from 'notistack';

import { ICategoryItem } from '../../../app/pages/home/categories/interfaces';
import { getFavoritesCagegories } from '../../../app/crud/categories.crud';
import { useFormatMessage } from '../../../app/hooks';
import { getResponseMessage } from '../../../app/utils/utils';

export function useGetFavoritesCategories() {
  const fm = useFormatMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [categories, setCategories] = React.useState<ICategoryItem[]>([]);
  const [loading, setLoading] = React.useState(false);

  const getCategories = () => {
    setLoading(true);
    getFavoritesCagegories()
      .then(res => {
        setCategories(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { getCategories, categories, loading };
}
